import { ICreateProject } from '../project/types';
import { ICreateThougth } from '../thougth/types';

export const types = {
    START_UPLOAD: 'START_UPLOAD',
    START_UPLOAD_SUCCESS: 'START_UPLOAD_SUCCESS',
    START_UPLOAD_FAIL: 'START_UPLOAD_FAIL',

    GET_UPLOAD_SESSION: 'GET_UPLOAD_SESSION',
    GET_UPLOAD_SESSION_SUCCESS: 'GET_UPLOAD_SESSION_SUCCESS',
    GET_UPLOAD_SESSION_FAIL: 'GET_UPLOAD_SESSION_FAIL',

    PAUSE_UPLOAD: 'PAUSE_UPLOAD',

    RESUME_UPLOAD: 'RESUME_UPLOAD',

    UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',

    UPLOAD_COMPLETE: 'UPLOAD_COMPLETE',

    UPLOAD_FAILED: 'UPLOAD_FAILED',

    PROGRESS_REPORT: 'PROGRESS_REPORT',

    COMPLETE_MULTIPART_UPLOAD: 'COMPLETE_MULTIPART_UPLOAD',
    COMPLETE_MULTIPART_UPLOAD_SUCCESS: 'COMPLETE_MULTIPART_UPLOAD_SUCCESS',
    COMPLETE_MULTIPART_UPLOAD_FAIL: 'COMPLETE_MULTIPART_UPLOAD_FAIL',

    SAVE_UPLOAD: 'SAVE_UPLOAD',

    STOP_WATCHING_NETWORK: 'STOP_WATCHING_NETWORK',

    TERMINATE_UPLOAD: 'TERMINATE_UPLOAD',

    CLEAR_MESSAGE: 'CLEAR_MESSAGE',

    RESUME_UPLOAD_AFTER_RELOAD: 'RESUME_UPLOAD_AFTER_RELOAD',

    SIGNED_URL_UPLOAD: 'SIGNED_URL_UPLOAD',
    SIGNED_URL_UPLOAD_SUCCESS: 'SIGNED_URL_UPLOAD_SUCCESS',
    SIGNED_URL_UPLOAD_FAIL: 'SIGNED_URL_UPLOAD_FAIL',
};

export type TUploadCategory = 'videos' | 'audios' | 'files' | 'images';

export interface IUploadInitialState {
    progress: number;
    isUploadInProgress: boolean;
    paused: boolean;
    currentChunkIndex: number;
    currentFile?: File;
    currentSessionData?: IUploadSession;
    errorMsg?: any;
    totalChunk?: number;
    uploadParts?: any[];
    uploadMessage?: string;
    currentUploadPayload?: IUploadPayload;
}

export interface IUploadPayload {
    file: File;
    uploadId: string;
    videoKey: string;
    initialPayload?: ICreateProject | ICreateThougth;
    projectId?: string;
    type?: 'project' | 'thougth' | 'audition' | 'event';
    url?: string;
    /** When uploading multiple items, this informs us when we are uploading the last item in th elist */
    isLastItem?: boolean;
    category?: TUploadCategory;
}

export interface IProgressReporter {
    chunk: number;
    progress: number;
    totalChunk: number;
}

export interface IUploadSession {
    videoKey: string;
    uploadId: string;
}

export interface ICompleteMultiPartUpload {
    filename: string;
    uploadId: string;
    parts: any;
    initialPayload?: ICreateProject | ICreateThougth;
    projectId?: string;
    url?: string;
    type?: 'project' | 'thougth' | 'audition' | 'event';
    /** When uploading multiple items, this informs us when we are uploading the last item in th elist */
    isLastItem?: boolean;
    category?: TUploadCategory;
}

export interface ICompleteMultipartUploadResponse {
    location: string;
    url?: string;
    type?: 'project' | 'thougth' | 'audition' | 'event';
}

export interface ISaveUpload {
    currentChunkIndex: number;
    uploadedParts: any[];
}

export interface IInitializeUploadSession {
    /** The Id of the project or thought */
    projectId: string;
    /** The file to b euploaded */
    project_file: File;
    initialPayload: ICreateProject | ICreateThougth;
    url?: string;
    type?: 'project' | 'thougth' | 'audition' | 'event';
    isLastItem?: boolean;
    category?: TUploadCategory;
}

export interface IGenericUploader {
    /** Id of the document */
    id: string;
    /** example audition, contest */
    collection: string;
    /** e.g media */
    path: string;
    /** e.g images */
    directory: string;
    /** files */
    files: File[];
}
